import { NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { ItemsHeaderBlock } from "../../../../../api/packbo/models/items-header-block";

@Component({
    selector: "packbo-simple-header",
    templateUrl: "./simple-header.template.html",
    imports: [DirectusTranslationPipe, NgOptimizedImage]
})
export class SimpleHeaderComponent {
    public readonly headerBlock = input.required<ItemsHeaderBlock>();
}
